export const sheet1Spec = [
  'title',
  'code',
  'theAgentCode',
  'developer',
  'launchPriceSqm',
  'currentPriceSqm',
  'startingPrice',
  'startingCurrentPrice',
  'startingResalePrice',
  'resalePriceSqm',
  'rentalPrice',
  'rentalPriceSqm',
  'capitalGain',
  'rentalYield',
  'lat',
  'long',
  'yearLaunch',
  'yearComplete',
  'projectType',
  'projectStatus',
  'avgRoomSize',
  'totalUnits',
  'parkingLot',
  'percentSold',
  'unitsLeft',
  'constructionStatus',
  'distanceFromBts',
  'station',
  'floor',
  'furniturePackage',
  'unitsType',
  'ceiling',
  'facility',
  'sinkingFund',
  'commonFee',
  'projectStatus2',
  'absorptionRateAll',
  'absorptionRateLastQ',
  'estimateTimeToDairn' 
]

export const sheet2Spec = [
  'code',
  'Project Name (use this column)',
  'Completion Year',
  'roomType',
  'Mode sqm',
  'roomSize',
  'resalePriceSqm',
  'Avg.Rent Package',
  'rentalPriceSqm',
  'startingResalePrice',
  'startingPrice',
  'totalUnits',
  'soldUnits',
  'unitsLeft',
  'percentSold',
  'rentalYield',
  'capitalGain'
];


// WEBPACK FOOTER //
// ./src/utils/csv.js